import { render, staticRenderFns } from "./AssignAttachmentTab.vue?vue&type=template&id=23989970&scoped=true&"
import script from "./AssignAttachmentTab.vue?vue&type=script&lang=js&"
export * from "./AssignAttachmentTab.vue?vue&type=script&lang=js&"
import style0 from "./AssignAttachmentTab.vue?vue&type=style&index=0&id=23989970&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23989970",
  null
  
)

export default component.exports